// extracted by mini-css-extract-plugin
export default {"formula":"YNulWBAjN4_JImPubE0a","fraction":"rXCGk1qhaVwPMWPrDE_R","quotient":"wXe50d5H6dxcR8S0RLNX"};